import { useTranslation } from "react-i18next"
import HeaderLabel from "../headerLabel"
import { SettingSectionWrapper } from "./styles"
import SettingsIcon from "@assets/svg/SettingsIcon.svg?react"
import { Checkbox } from "@mui/material"
import CustomTable from "@Common/CustomTable"
import { useEffect, useMemo, useState } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { IFormAutomationCentre } from "../.."
import { useGetGetListingManagment } from "@services"
interface IProps {
	listSelectedPropertiesData: number[]
}
export default function SettingSection({ listSelectedPropertiesData }: IProps) {
	/* ---------------------------------- Hooks --------------------------------- */
	const {
		t,
		i18n: { language },
	} = useTranslation()

	const { watch, control, setValue } = useFormContext<IFormAutomationCentre>()
	const senderChannelsWatch = watch("senderChannels")
	/* ------------------------------- Local State ------------------------------ */
	const [activePage, setActivePage] = useState(1)
	const [perPage, onPerPageChange] = useState("50")

	/* ---------------------------------- API'S --------------------------------- */
	const { data: listingData } = useGetGetListingManagment({
		pageNumber: activePage,
		pageSize: Number(perPage),
	})
	const [selectedRows, setSelectedRows] = useState<number[]>([])
	const columns = [
		{
			field: "propertyName",
			headerName: t("COMMON.PROPERTY"),
			flex: 1,
			renderCell: (params: any) => (
				<p
					className='columnsContent'
					style={{
						textAlign: `${language === "ar" ? "right" : "left"}`,
						margin: 0,
					}}
				>
					{params.row.propertyName}
				</p>
			),
		},
		{
			field: "propertyLocation",
			headerName: t("AutomationCentre.TITLE"),
			flex: 1,
			renderCell: (params: any) => (
				<p
					className='columnsContent'
					style={{
						textAlign: `${language === "ar" ? "right" : "left"}`,
						margin: 0,
					}}
				>
					{params.row.propertyLocation}
				</p>
			),
		},
	]
	/* ------------------------------- Cache Lists ------------------------------ */
	const transmissionChannelsList = useMemo(() => {
		const data = senderChannelsWatch?.map((item) => ({
			id: item.id.toString(),
			label: item.name,
			isActive: item.isActive,
		}))
		return data ?? []
	}, [senderChannelsWatch])

	const ListingManagment = useMemo(() => {
		return (
			listingData?.result.map((item) => ({
				id: item.propertyId,
				propertyName: item.propertyName,
				propertyLocation: item.propertyLocation,
			})) ?? []
		)
	}, [listingData])

	/* -------------------------------- Functions ------------------------------- */
	const handleRowSelection = (selectionModel: any) => {
		setSelectedRows(selectionModel)
		setValue("properties", selectionModel)
	}

	useEffect(() => {
		if (listSelectedPropertiesData.length > 0) {
			setSelectedRows(listSelectedPropertiesData)
			setValue("properties", listSelectedPropertiesData)
		}
	}, [listSelectedPropertiesData])
	return (
		<SettingSectionWrapper>
			<HeaderLabel
				icons={<SettingsIcon />}
				label={t("AutomationCentre.settings")}
				tooltip='test'
			/>
			<div className='lastSection'>
				<div className='transmissionChannelsContainer'>
					<p>{t("AutomationCentre.transmission_channels")}</p>
					<div className='containerCheckBoxs'>
						{transmissionChannelsList.map((item, index) => (
							<div key={item.id}>
								<Controller
									name={`senderChannels.${index}.isActive`}
									control={control}
									render={({ field }) => (
										<Checkbox
											checked={field.value}
											onChange={(e) =>
												setValue(
													`senderChannels.${index}.isActive`,
													e.target.checked
												)
											}
										/>
									)}
								/>
								<p>{item.label}</p>
							</div>
						))}
					</div>
				</div>
				<div className='containerCustomTable'>
					{/* <div className='containerSearchInput'>
						<Input
							name='searchInput'
							placeholder={t("CATEGORYMANAGER.SEARCH")}
						/>
					</div> */}
					<div>
						<CustomTable
							columns={columns}
							rows={ListingManagment ?? []}
							totalPages={Math.ceil((listingData?.totalRecords ?? 0) / Number(perPage))}
							totalRecords={listingData?.totalRecords ?? 0}
							setActivePage={setActivePage}
							activePage={activePage}
							onPerpageChange={onPerPageChange}
							perPage={perPage}
							checkboxSelection
							onRowSelectionModelChange={handleRowSelection}
							rowSelectionModel={selectedRows}
							listPerPagesNumber={[
								{ label: "50", value: "50" },
								{ label: "100", value: "100" },
								{ label: "200", value: "200" },
							]}
							showFilterBar={false}
						/>
					</div>
				</div>
			</div>
		</SettingSectionWrapper>
	)
}
